export default __webpack_public_path__ + "static/user4-85339a0beb42f816d4bff9c084e428ba.jpg";